import { createReducer, } from '@reduxjs/toolkit';
import { buildRelevanceSortCriterion, SortBy, } from '../../sort/sort.js';
import { setContext, setView } from '../context/context-actions.js';
import { fetchProductListing } from '../product-listing/product-listing-actions.js';
import { restoreProductListingParameters } from '../product-listing-parameters/product-listing-parameters-actions.js';
import { executeSearch } from '../search/search-actions.js';
import { restoreSearchParameters } from '../search-parameters/search-parameters-actions.js';
import { applySort } from './sort-actions.js';
import { getCommerceSortInitialState, } from './sort-state.js';
export const sortReducer = createReducer(getCommerceSortInitialState(), (builder) => {
    builder
        .addCase(applySort, (state, action) => {
        state.appliedSort = action.payload;
    })
        .addCase(fetchProductListing.fulfilled, handleFetchFulfilled)
        .addCase(executeSearch.fulfilled, handleFetchFulfilled)
        .addCase(setContext, getCommerceSortInitialState)
        .addCase(setView, getCommerceSortInitialState)
        .addCase(restoreSearchParameters, handleRestoreParameters)
        .addCase(restoreProductListingParameters, handleRestoreParameters);
});
function handleFetchFulfilled(state, action) {
    const response = action.payload.response;
    state.appliedSort = mapResponseSortToStateSort(response.sort.appliedSort);
    state.availableSorts = response.sort.availableSorts.map(mapResponseSortToStateSort);
}
const mapResponseSortToStateSort = (sort) => {
    if (sort.sortCriteria === SortBy.Relevance) {
        return buildRelevanceSortCriterion();
    }
    return {
        by: SortBy.Fields,
        fields: (sort.fields || []).map(({ field, direction, displayName }) => ({
            name: field,
            direction,
            displayName,
        })),
    };
};
function handleRestoreParameters(state, action) {
    if (action.payload.sortCriteria) {
        state.appliedSort = action.payload.sortCriteria;
        return;
    }
    state.appliedSort = getCommerceSortInitialState().appliedSort;
}
